var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2",attrs:{"text":"","rounded":"","color":"info","small":"","loading":_vm.carregando},on:{"click":function($event){return _vm.atualizarAtestados()}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"18"}},[_vm._v("mdi-refresh")]),_vm._v(" Atualizar")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }